// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import store from './store'
import api from './request/api' // 导入api接口
import wechatAuth from './utils/wechatAuth'//微信登录插件
import './assets/style/iconfont.css'
import './utils/flexible'
import App from './App'
import router from './router'
import '../theme/index.css'
import scroll from 'vue-seamless-scroll'




import tinymce from 'tinymce'
import VueTinymce from '@packy-tang/vue-tinymce'

import NPlayer from "@nplayer/vue";

import less from 'less';

// 复制
import clipboard from 'clipboard'


Vue.use(less);
Vue.use(NPlayer);

Vue.prototype.$tinymce = tinymce // 将全局tinymce对象指向给Vue作用域下
Vue.use(VueTinymce)              // 安装vue的tinymce组件

const qs= require('qs');

Vue.prototype.bus = new Vue()
Vue.prototype.$api = api; // 将api挂载到vue的原型上复制代码
Vue.config.productionTip = false

Vue.use(wechatAuth, {appid:'wx08ce7cf7c8886e10'});
Vue.use(ElementUI)
Vue.use(scroll)
// 注册全局过滤器
import filters from './utils/filter';

console.log('log',filters);
Object.keys(filters).forEach((key) => {
  Vue.filter(key,filters[key])
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
});

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })






// WEBPACK FOOTER //
// ./src/main.js